import { List, ListItemButton, ListItemText } from "@mui/material";
import * as React from "react";
import { useXoraiaValue } from "../../../../hooks/useXoraia";
import { useXPathValue } from "../../../../hooks/useXPath";
import { MENU_LINKS } from "../../../../utils/constants/core/MENU_LINKS";

const MenuList: React.FC<{}> = ({}) => {
  const xPath = useXPathValue();

  const { env, Link } = useXoraiaValue();

  return (
    <List
      disablePadding
      sx={{
        flex: 1,
        fontFamily: "inherit",
        "& .MuiListItem-container:not(:last-of-type)": {
          borderBottom: 1,
          borderBottomColor: "rgba(0, 0, 0, 0.12)",
        },
      }}
    >
      {MENU_LINKS.map((page) => {
        const isActived = xPath === page.path;

        return (
          <ListItemButton
            href={env === "prod" ? page.path : "#"}
            LinkComponent={Link}
            key={page.path}
            selected={isActived}
          >
            <ListItemText
              primary={page.label}
              primaryTypographyProps={{
                sx: {
                  fontFamily: "inherit",
                  lineHeight: "1em",
                  fontWeight: 600,
                },
              }}
            />
          </ListItemButton>
        );
      })}
    </List>
  );
};

export default MenuList;
